import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { logout } from "src/store/authSlice";
import { Page } from "src/interfaces/Page";
import { RootState } from "../../store";
import { coursesSelector } from "../coursesSlice";
import { getWebwatchCourses } from "src/actions/courseActions/learnerCourseActions";

const webwatchCoursesPaginationAdapter = createEntityAdapter<Page>();

const initialState = {
  pages: webwatchCoursesPaginationAdapter.getInitialState(),
  total: 0,
  totalItems: 0,
};

export const webwatchCoursesPaginationSlice = createSlice({
  name: "webwatchCourses/pagination",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWebwatchCourses.fulfilled, (state, { payload }) => {
      return {
        pages: webwatchCoursesPaginationAdapter.upsertOne(
          { ...state.pages },
          {
            id: parseInt(payload.currentPage),
            items: payload?.data?.map((item: any) => item.courses.id),
          }
        ),
        total: payload.pages,
        totalItems: payload.items,
      };
    });
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const adapterSelectors = webwatchCoursesPaginationAdapter.getSelectors(
  (s: RootState) => s.webwatchCoursePagination.pages
);

export const webwatchCoursesPaginationSelectors = {
  pages: adapterSelectors,
  get: (state: RootState, page: number) =>
    adapterSelectors
      .selectById(state, page)
      ?.items.map((id: number) =>
        coursesSelector.coursesSelector.selectById(state, id)
      ) || [],
  totalPages: (state: RootState) => state.webwatchCoursePagination.total,

  // total: (state: RootState) => state.continueLearning.totalItems,
};
